import UploadNewsForm from "../../UploadNewsForm";
import { createChurchNews } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewChurchNews() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createChurchNews(title, description, image);
      if (result) {
        navigate("/church-news/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Church News"}
          breadCrumbText={"Create New"}
          goBackLink={"/church-news/all"}
        />
      </Container>
    </>
  );
}
